import { useContext, useState } from 'react'
import { Formik, Form } from 'formik'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import * as Yup from 'yup'
import { Row, Group, FieldInput } from '@/components/form'
import { Button } from '@/components/button'
import { requestResetPassword } from '@/models/auth/ports'
import { pushToDatalayer } from '@/utils/push-datalayer'
import BackButton from './back-button'
import HeaderDiv from './header-div'
import Context from '../context'

const StyledForm = styled(Form)`
  width: 100%;
`

const ButtonContainer = styled(Group)`
  text-align: center;
  margin: 0 auto;
`

const ForgotPassword = () => {
  const { t } = useTranslation()
  const { username, setCurrentStep } = useContext(Context)
  const [usernameClicked, setUsernameClicked] = useState(false)

  const validationSchema = Yup.object().shape({
    username: Yup.string().email().required()
  })

  const onSubmit = async (values, { setSubmitting }) => {
    const { response } = await requestResetPassword(values)
    setSubmitting(false)
    if (!response.ok) return
    pushToDatalayer({
      event: 'web-login-reset-password-submit-button'
    })
    setCurrentStep('resetPasswordSuccess')
  }

  return (
    <>
      <BackButton onClick={() => setCurrentStep('password')} />
      <HeaderDiv
        headingText={t('b.auth.view.forgot_your_password.text', 'Forgot your Password?')}
        subheadingText={t(
          'b.auth.view.enter_email_to_receive_instructions.text',
          'Enter your email below and we will email instructions for setting a new one.'
        )}
        bottom={20}
      />
      <Formik
        initialValues={{ username: username || '' }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ isSubmitting, isValid }) => (
          <StyledForm noValidate>
            <Row>
              <Group col={12}>
                <FieldInput
                  name="username"
                  type="email"
                  autoFocus
                  placeholder={t('b.auth.view.email.label', 'Email')}
                  required
                  hideError={!usernameClicked}
                  onClick={() => setUsernameClicked(true)}
                />
              </Group>
            </Row>
            <Row>
              <ButtonContainer col={12}>
                <Button
                  id="web-reset-password-button"
                  theme="primary"
                  type="submit"
                  width="100%"
                  disabled={isSubmitting || !isValid}
                >
                  {t('b.auth.view.reset_password.title', 'Reset Password')}
                </Button>
              </ButtonContainer>
            </Row>
          </StyledForm>
        )}
      </Formik>
    </>
  )
}

export default ForgotPassword
